<template>
    <div>
        <div id="page">
            <div class="page-content">

               <div class="page-title page-title-small">
				<h2>
                    <button @click.prevent="goBack">
                        <i class="fa fa-arrow-right"></i>
                    </button><span v-if="mode=='f'">فراموشی رمز عبور</span><span v-else>لینک فعالسازی</span></h2>
			</div>
			
                <div class="card header-card shape-rounded" data-card-height="150">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                    <div class="card-bg bg-20"></div>
                </div>

                  <div class="card card-style text-center" style="margin-top:100px" v-if="step==1">
                     <div class="content pb-2" >
                        <div class="mb-5">
                            <i class="fa fa-check color-green fa-5x pt-3 icon-size"></i>
                        </div>
                        <p>{{msg}}</p>
                    </div>
                </div>

                <div class="card card-style text-center" style="margin-top:100px" v-if="step==2">
                     <div class="content pb-2" >
                        <div class="mb-5">
                            <i class="fa fa-exclamation-triangle color-red1-dark fa-5x pt-3 icon-size"></i>
                        </div>
                        <p>{{msg}}</p>
                    </div>
                </div>

                <div class="card card-style" v-if="step==3">
				<div class="content mt-2 mb-0">
					<p>لطفا رمز عبور جدید خود را وارد کنید: </p>
					<div class="input-style input-style-2 has-icon input-required mt-4">
						<i class="input-icon fa fa-lock"></i>
						<span class="color-highlight input-style-1-active input-style-1-inactive">رمز عبور جدید</span>
						<input type="password" v-model="password" @blur="v$.password.$touch()" :class="{invalid:v$.password.$error}">
						<p class="text-danger" v-if="v$.password.required.$invalid && v$.password.$dirty">لطفا رمز عبور جدید را وارد کنید</p>
						<p class="text-danger" v-if="v$.password.minLength.$invalid && v$.password.$dirty">رمز عبور می بایست حداقل ۶ کاراکتر باشد.</p>

					</div>

					<div class="input-style input-style-2 has-icon input-required mt-4">
						<i class="input-icon fa fa-lock"></i>
						<span class="color-highlight input-style-1-active input-style-1-inactive">تکرار رمز عبور </span>
						<input type="password" v-model="confirmPassword" @blur="v$.confirmPassword.$touch()" :class="{invalid:v$.confirmPassword.$error}">
						<p class="text-danger" v-if="v$.confirmPassword.required.$invalid && v$.confirmPassword.$dirty">لطفا تکرار رمز عبور را وارد کنید</p>
						<p class="text-danger" v-if="v$.confirmPassword.sameAsPassword.$invalid && v$.confirmPassword.$dirty">رمز عبور جدید و تکرار آن باهم مطابقت ندارند.</p>
					</div>

					<button :disabled="v$.confirmPassword.$error || v$.password.$error || Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="SavePassword">ثبت</button>

				</div>
			</div>
            </div>     
        </div>
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
                <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                    <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا منتظر بمانید ...</div>
                </div>
            </transition>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
	import {
        required, sameAs, minLength
	} from "@vuelidate/validators";
    export default {
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                res: 0,
                step:0,
                msg:null,
                mode:this.$route.params.mode,
                password: "",
				confirmPassword:"",
				oldPassword: "",
                Loading:false,
                email:""
            }
        },
        mounted(){
            this.ValidateEmail();
        },
        methods: {
            ValidateEmail() {
                this.$http.get('Account/ValidateUserEmail?key='+this.$route.params.key+"&mode="+this.mode).then(response => {
                    console.log(response);
                    if (response.data !== null && response.data.userId>0) {
                        
                            if(this.mode=="r")
                            {
                                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                                const login = {
                                phoneNumber: response.data.emailAddress,
                                password: response.data.password
                                };
                                this.Loading = true;
                                this.$store.dispatch("LoginUser", login);
                                this.Loading = true;
                                }
                                else{
                                this.step=1;
                                this.msg="فعالسازی حساب کاربری با موفقیت انجام شد...";
                            }
                            }
                            else if(this.mode=="f")
                            {
                                this.step=3
                            }
                            else if(this.mode=="v")
                            {
                               this.step=1;
                                this.msg="فعالسازی ایمیل با موفقیت انجام شد..."; 
                            }
                            
                        
                        
                    }
                    else {
						this.step=2;
                        this.msg="لینک فعالسازی معتبر نمی باشد...";
                        this.Loading = false;
                    }
                   
                }, data => {
                    console.log(data);
                });
            },
             SavePassword() {
                this.Loading = true;
                this.$http.get('Account/SaveNewPasswordByEmail?email='+this.email+'&key='+ this.$route.params.key+'&pass='+ this.password).then(response => {
                    console.log(response);
                    if (response.data !== null && response.data.userId>0) {
                        const login = {
                            phoneNumber: response.data.emailAddress,
                            password: response.data.password
                        };
                        this.Loading = true;
						this.$store.dispatch("LoginUser", login);
                        this.Loading = true;
                    }
                    else {
						this.showErrorMessage(response.data);
                        this.Loading = false;
                    }
                   
                }, data => {
                    console.log(data);
                });
            },
             SignOutUser() {
                this.$store.dispatch("SignOutUser");
            },
        },
        validations() {
			return{
			oldPassword: {
				required
			},
            password: {
				required,
                minLength: minLength(6)
            },
			confirmPassword: {
                required,
                sameAsPassword: sameAs(this.password)
			},
			registCode: {
                required
			},
            userInput: {
                required
            },
            }
		}
    }
</script>